import React, { createElement, FunctionComponent } from 'react';
import styled, { css } from 'styled-components';

interface ComponentProps extends Component {
  icon: FunctionComponent<SimpleObject> | string;
  size?: number;
  mb?: number;
}

const Root = styled(({ className, icon, size }: ComponentProps) => {
  if (typeof icon === 'string') {
    return <img src={icon} className={className} style={{ height: size }} alt="" />;
  } else {
    return createElement(icon, { className, size });
  }
})`
    ${({ size, mb }) => css`
        flex-shrink: 0;
        width: auto;
        min-width: auto;
        height: ${size ? size : 'auto'}px;
        margin-bottom: ${mb ? mb : 0}px;
    `}
`;


const Image = ({ icon, className, size, mb }: ComponentProps) => <Root icon={icon} size={size} className={className} mb={mb} />;

export default Image;
